var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5128 9.24316C19.0404 9.24316 18.5577 9.28425 18.075 9.38695C15.2404 9.93127 12.9809 12.2215 12.4469 15.0561C11.9539 17.7367 12.9399 20.2015 14.7269 21.7934C15.1685 22.1837 15.4047 22.728 15.4047 23.3032V25.6756C15.4047 26.8053 16.3291 27.7297 17.4588 27.7297H17.7463C18.1058 28.3459 18.7528 28.7567 19.5128 28.7567C20.2728 28.7567 20.9301 28.3459 21.2793 27.7297H21.5669C22.6966 27.7297 23.6209 26.8053 23.6209 25.6756V23.3032C23.6209 22.7383 23.8469 22.1837 24.2782 21.8037C25.7674 20.4891 26.702 18.5686 26.702 16.4324C26.702 12.4578 23.4874 9.24316 19.5128 9.24316ZM20.0263 20.5405H18.9993V17.8805L17.1199 16.0113L17.8491 15.2821L19.5128 16.9459L21.1766 15.2821L21.9058 16.0113L20.0263 17.8907V20.5405V20.5405ZM21.0534 25.6756C21.0431 25.6756 21.0328 25.6653 21.0226 25.6653V25.6756H18.0031V25.6653C17.9928 25.6653 17.9826 25.6756 17.9723 25.6756C17.6847 25.6756 17.4588 25.4497 17.4588 25.1621C17.4588 24.8745 17.6847 24.6486 17.9723 24.6486C17.9826 24.6486 17.9928 24.6588 18.0031 24.6588V24.6486H21.0226V24.6588C21.0328 24.6588 21.0431 24.6486 21.0534 24.6486C21.3409 24.6486 21.5669 24.8745 21.5669 25.1621C21.5669 25.4497 21.3409 25.6756 21.0534 25.6756ZM21.0534 23.6215H17.9723C17.6847 23.6215 17.4588 23.3956 17.4588 23.108C17.4588 22.8205 17.6847 22.5945 17.9723 22.5945H21.0534C21.3409 22.5945 21.5669 22.8205 21.5669 23.108C21.5669 23.3956 21.3409 23.6215 21.0534 23.6215Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/lightBulb.461620ef8536ae67042e4d4d24a59746.svg";
export { ForwardRef as ReactComponent };